<qrcode
  [qrdata]="data.url | async"
  [width]="qrCodeWidth"
  [errorCorrectionLevel]="'M'"
></qrcode>
